import React from "react";
import { FormattedMessage } from "react-intl";
const SearchResultMessage = ({ searchFilter }) => {
  return (
    <div className="results">
      <p className="py-1 m-0">
        <FormattedMessage
          id="id.searchResultMessage"
          defaultMessage="Showing all main identities linked to {text}"
          values={{ text: searchFilter }}
        />
      </p>
    </div>
  );
};

export default SearchResultMessage;
